import { Helmet } from "react-helmet";
import InvalidPage from "../sections/error/invalidPage";

const NotFoundPage = () => {
    <Helmet>
        <title>Page Not Found</title>
    </Helmet>

    return (
        <>
            <InvalidPage />
        </>
    );
}

export default NotFoundPage;